'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var _extends = require('@babel/runtime/helpers/extends');
var React = require('react');
var IconExpand = require('@narvar/nth-bit-icon-expand');
var IconContract = require('@narvar/nth-bit-icon-contract');
var ExpandableImage_module = require('./ExpandableImage.module.css.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var _extends__default = /*#__PURE__*/_interopDefaultLegacy(_extends);
var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var IconExpand__default = /*#__PURE__*/_interopDefaultLegacy(IconExpand);
var IconContract__default = /*#__PURE__*/_interopDefaultLegacy(IconContract);

const defaultDimensions = {
  expanded: {
    width: '100%',
    maxWidth: '19.5rem'
  },
  contracted: {
    width: '100%',
    maxWidth: '5rem'
  }
};
const ExpandableImage = ({
  expandAriaLabel,
  contractAriaLabel,
  dimensions = defaultDimensions,
  onContract,
  onExpand,
  onValidImageDetermined,
  ...imgAttrs
}) => {
  const [expanded, setExpanded] = React.useState(false);
  const img = React.useRef(null);
  const handleContract = () => {
    setExpanded(false);
  };
  const handleExpand = () => {
    setExpanded(true);
  };
  const handleTransitionEnd = () => {
    const fn = expanded ? onExpand : onContract;
    if (fn) fn();
  };
  React.useEffect(() => {
    if (!onValidImageDetermined) return;

    // Periodically check to see if the naturalWidth of the image is greater than 0.
    // If it is, we have an image loaded.
    const imageCheck = setInterval(() => {
      const imgEl = img?.current;
      if (imgEl && imgEl.naturalWidth) {
        onValidImageDetermined(true);
        clearInterval(imageCheck);
        clearTimeout(imageCheckTimeout);
      }
    }, 100);

    // Stop checking for a valid image after 5 seconds
    const imageCheckTimeout = setTimeout(() => {
      onValidImageDetermined(false);
      clearInterval(imageCheck);
    }, 5000);
    return () => {
      clearInterval(imageCheck);
    };
  }, [onValidImageDetermined]);
  const {
    label,
    icon,
    handleClick
  } = expanded ? {
    label: contractAriaLabel,
    icon: /*#__PURE__*/React__default["default"].createElement(IconContract__default["default"], {
      themed: false
    }),
    handleClick: handleContract
  } : {
    label: expandAriaLabel,
    icon: /*#__PURE__*/React__default["default"].createElement(IconExpand__default["default"], {
      themed: false
    }),
    handleClick: handleExpand
  };
  return /*#__PURE__*/React__default["default"].createElement("div", {
    className: ExpandableImage_module["default"].container,
    style: {
      ...(expanded ? dimensions.expanded : dimensions.contracted)
    },
    onTransitionEnd: handleTransitionEnd
  }, /*#__PURE__*/React__default["default"].createElement("img", _extends__default["default"]({
    className: ExpandableImage_module["default"].img,
    ref: img,
    alt: expanded ? expandAriaLabel : contractAriaLabel
  }, imgAttrs)), /*#__PURE__*/React__default["default"].createElement("button", {
    className: ExpandableImage_module["default"].button,
    "aria-label": label,
    onClick: handleClick
  }, icon));
};

exports["default"] = ExpandableImage;
